"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LabelContainer = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

/*
hack for React syntetic event bug
https://github.com/facebook/react/issues/10109
can be removed when issue would resolved
*/
var reactDisabledBugHack = "\n  padding-top: 2px;\n  padding-bottom: 2px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n";

var styles = function styles(_ref) {
  var selected = _ref.selected,
      focused = _ref.focused,
      color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(_styleConsts.buttonReset, "\n  min-width:100%;min-height:32px;padding:8px 16px;user-select:none;color:", color.black2, ";font-size:14px;font-weight:", _styleConsts.font.weight.normal, ";outline:none;line-height:1.43;justify-content:space-between;", selected ? "\n    font-weight: ".concat(_styleConsts.font.weight.bold, ";\n    color: ").concat(color.black1, ";\n    background-color: ").concat(color.grey4, ";\n  ") : '', "\n\n  ", focused ? "\n    background-color: ".concat(color.accentBackground, ";\n  ") : '', "\n\n  &:hover{background-color:", color.accentBackground, ";}&:disabled{color:", color.grey1, ";background-color:inherit !important;cursor:not-allowed;", reactDisabledBugHack, "}")
  );
};

var StyledOption = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("button", {
  target: "css-3qh6nw0"
})(styles));
var LabelContainer =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-3qh6nw1"
})("display:flex;align-items:center;justify-content:space-between;width:100%;");
exports.LabelContainer = LabelContainer;
var _default = StyledOption;
exports.default = _default;